import { useState } from 'react';

export const useData = <S extends Record<string, any>>(defaultState: S) => {
  const [data, setData] = useState(defaultState);

  const setValueFromKey =
    <K extends keyof S>(key: K) =>
    (value: S[K]) =>
      setData((prevData) => ({
        ...prevData,
        [key]: value,
      }));

  return {
    data,
    setData,
    setValueFromKey,
  };
};

export const useItems = <Item>(initialValue: Item[] = []) => {
  const [items, setItems] = useState<Item[]>(initialValue);

  const updateItem = (index: number) => (updateFn: (item: Item) => Item) => {
    const item = items.at(index);
    if (item) {
      items[index] = updateFn(item);
      setItems([...items]);
    }
  };

  return {
    items,
    setItems,
    updateItem,
  };
};
